import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ChevronLeft, ChevronRight, Instagram } from "lucide-react";
import { Reveal } from "@/components/ui-bits";

const TESTIMONIOS = [
  {
    quote:
      "Una historia con la cual identificarse y ver que no están solas, que no son las únicas. Que así como se sale de esta, se sale de cualquiera.",
    name: "Viviana de Ferrari",
    role: "Especialista en Inteligencia Emocional",
    handle: "@vivianadeferrari",
  },
  {
    quote:
      "Habiendo leído el libro considero imprescindible que se haga una película.",
    name: "Manuela Camacho",
    role: "Periodista",
    handle: "@manuela_camacho",
  },
  {
    quote:
      "Esta película es una conversación que este país necesita. Es una herramienta de educación emocional. Es la posibilidad de que miles de mujeres puedan verse y reconocerse. Para mí, como psicóloga clínica, no es un proyecto artístico solamente. Es un proyecto de salud mental.",
    name: "Pamela Núñez del Prado",
    role: "Psicóloga clínica",
    handle: "@pam.nunezdelprado",
  },
  {
    quote:
      "Una historia que nos permite cuestionar, reflexionar, poner en debate nuestras propias creencias. Es bien determinante lo que puede hacer el cine en este momento y lo que estas imágenes en pantalla grande podrían generar hacia el futuro.",
    name: "Pamela Romero Wilson",
    role: "Founder HELLOWPRV",
    handle: "@pamelaromerowilson",
  },
  {
    quote: "Debería ser completamente una película.",
    name: "Ursula Moscoso",
    role: "Directora ejecutiva de Kunan",
    handle: "@ursulamoscoso_",
  },
];

export default function Testimonios() {
  const [i, setI] = useState(0);
  const [dir, setDir] = useState(0);
  const n = TESTIMONIOS.length;

  const move = (d) => {
    setDir(d);
    setI((prev) => (prev + d + n) % n);
  };

  const t = TESTIMONIOS[i];

  return (
    <Reveal>
      <div data-testid="testimonios" className="mt-16">
        <div className="relative bg-white rounded-3xl border border-[#ece5d6] px-6 sm:px-14 py-12 sm:py-16 min-h-[340px] flex flex-col justify-center overflow-hidden">
          <AnimatePresence mode="wait" custom={dir}>
            <motion.figure
              key={i}
              custom={dir}
              initial={{ opacity: 0, x: dir >= 0 ? 60 : -60 }}
              animate={{ opacity: 1, x: 0 }}
              exit={{ opacity: 0, x: dir >= 0 ? -60 : 60 }}
              transition={{ duration: 0.45, ease: [0.22, 1, 0.36, 1] }}
              className="text-center max-w-3xl mx-auto"
            >
              <blockquote className="font-medium text-2xl sm:text-3xl lg:text-4xl leading-snug text-[#141414]">
                “{t.quote}”
              </blockquote>
              <figcaption className="mt-8">
                <p className="font-bold text-lg text-[#C20A78]">{t.name}</p>
                <p className="text-sm text-[#6E6A66] mt-1">{t.role}</p>
                <p className="inline-flex items-center gap-1.5 text-sm text-[#E84FA0] mt-1">
                  <Instagram size={15} /> {t.handle}
                </p>
              </figcaption>
            </motion.figure>
          </AnimatePresence>

          <button
            data-testid="testimonios-prev"
            onClick={() => move(-1)}
            className="absolute left-3 sm:left-5 top-1/2 -translate-y-1/2 h-11 w-11 rounded-full bg-[#C20A78] text-white flex items-center justify-center hover:bg-[#8F0759] transition-colors"
            aria-label="Anterior"
          >
            <ChevronLeft size={22} />
          </button>
          <button
            data-testid="testimonios-next"
            onClick={() => move(1)}
            className="absolute right-3 sm:right-5 top-1/2 -translate-y-1/2 h-11 w-11 rounded-full bg-[#C20A78] text-white flex items-center justify-center hover:bg-[#8F0759] transition-colors"
            aria-label="Siguiente"
          >
            <ChevronRight size={22} />
          </button>
        </div>

        <div className="mt-6 flex justify-center gap-2.5">
          {TESTIMONIOS.map((_, idx) => (
            <button
              key={idx}
              data-testid={`testimonios-dot-${idx}`}
              onClick={() => {
                setDir(idx > i ? 1 : -1);
                setI(idx);
              }}
              className={`h-2.5 rounded-full transition-all duration-300 ${
                idx === i ? "w-7 bg-[#C20A78]" : "w-2.5 bg-[#C20A78]/30 hover:bg-[#C20A78]/60"
              }`}
              aria-label={`Testimonio ${idx + 1}`}
            />
          ))}
        </div>
      </div>
    </Reveal>
  );
}
